module.exports = __webpack_public_path__ + "static/media/contact_me.3f65a3a3.jpg";